import BaseModel from './BaseModel';

class ServiceCenter extends BaseModel {
  constructor(data = {}, useCase = 0) {
    super(data);
    switch(useCase) {
      case 0:
      this.updateData(data);
      break;
      case 1:
      this.setApiData(data);
      break;
      case 2: 
      this.setApiDetailsData(data);
      break;
      default:
      this.updateData(data);
      break;
    }
  }

  setApiDetailsData = (data) => {
    this.id = data.id || "";
    this.name = data.name || "";
    this.service_center_type = data?.service_center_type?.toUpperCase() || "";
    this.ware_house = data.cs_ware_house_id || "";
    // this.branch_id = data.branch_id || "";
    // this.pincodes = data.pincode_ids || [];
    // this.categories = data.service_center_categories || [];
    if (data.work_hour){
      this.work_hours = `From - ${data.work_hour.start_time} To - ${data.work_hour.end_time}`;
      this.working_days = data.work_hour.days;
    }

    if(data.address){
      this.address = data.address.address || "";
      this.city = data.address.city || "";
      this.state = data.address.state || "";
      this.pincode = data.address.pincode_code || "";
    }

    if(data.service_location) {
        this.service_location_SLOC= `${data.service_location.location}`
    }
    this.tally_account_id = data.tally_account_id || "";
  }

  setApiData = (data) => {
    this.id = data.id;
    this.branch_id = data.branch_id
    this.service_center_type = data.service_center_type || "";
    this.sloc = data.sloc || "";
    this.name = data.name || "";
    this.tally_account_id = data.tally_account_id || "";
    this.cs_ware_house_id = data.cs_ware_house_id || "";
    this.branch_id = data.branch_id || "";
    this.pincodes = data.pincodes || data.pincode_ids || [];
    this.category_ids = data.category_ids || data.service_center_categories || [];
    this.existing_categories = data.service_center_categories || [];
    this.work_hour_id = data.work_hour.id || ""
    this.start_time = data.work_hour.start_time || "05:45";
    this.end_time = data.work_hour.end_time || "11:00";
    this.days = data.work_hour.days || ""
    this.address_id = data.address.id || ""
    this.address = data.address.address || "";
    this.pincode = data.address.pincode_id || "";
    this.city = data.address.city || "";
    this.state = data.address.state || "";
    this.state_id = data.address.state_id || "";
    this.latitude = data.address.latitude || "";
    this.longitude = data.address.longitude || "";
    if(data.settings){
      this.rental_services_available = data.settings.rental_services_available || false;
    }
  }

  updateData = (data) => {
    this.id = data.id;
    this.branch_id = data.branch_id || "";
    this.work_hour_id = data.work_hour_id || "";
    this.address_id = data.address_id || "";
    this.service_center_type = data.service_center_type || "";
    this.sloc = data.sloc || "";
    this.name = data.name || "";
    this.tally_account_id = data.tally_account_id || "";
    this.cs_ware_house_id = data.cs_ware_house_id || "";
    this.branch_id = data.branch_id || "";
    this.category_ids = data.category_ids || [];
    this.existing_categories = data.existing_categories || [];
    this.start_time = data.start_time || "05:45";
    this.end_time = data.end_time || "11:00";
    this.days = data.days || "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday";
    this.address = data.address || "";
    this.pincode = data.pincode || "";
    this.pincodes = data.pincodes || data.pincode_ids || [];
    this.city = data.city || "";
    this.state = data.state || "";
    this.state_id = data.state_id || "";
    this.service_center_categories_attributes = [];
    this.cluster_ids = data.cluster_ids || [];
    this.latitude = data.latitude || "";
    this.longitude = data.longitude || "";
    this.rental_services_available = data.rental_services_available || false;
    this.ops_pincodes = data.ops_pincodes || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      service_center: {
        service_center_type: this.service_center_type,
        sloc: this.sloc,
        name: this.name,
        tally_account_id: this.tally_account_id,
        cs_ware_house_id: this.cs_ware_house_id,
        branch_id: this.branch_id,
        settings : {
          rental_services_available: this.rental_services_available
        },
        service_center_categories_attributes : this.category_ids.map((id) => {
          return { category_id: id };
        }),
        address_attributes: {
          line_no_1: this.address,
          state: this.state,
          state_id: this.state_id,
          city: this.city,
          pincode_id: this.pincode,
          latitude: this.latitude,
          longitude: this.longitude,

        },
        work_hour_attributes: {
          start_time: this.start_time,
          end_time: this.end_time,
          days: this.days,
        },
        pincode_ids: this.pincodes,
      }
    }
  }

  toEditApiJson = () => {
    this.completeValidation();
    const apiJson = {
      id: this.id,
      service_center: {
        service_center_type: this.service_center_type,
        sloc: this.sloc,
        name: this.name,
        tally_account_id: this.tally_account_id,
        cs_ware_house_id: this.cs_ware_house_id,
        branch_id: this.branch_id,
        settings : {
          rental_services_available: this.rental_services_available
        },
        service_center_categories_attributes : this.prepareServiceCenterCategoryObj(),
        address_attributes: {
          id: this.address_id,
          line_no_1: this.address,
          state: this.state,
          state_id: this.state_id,
          city: this.city,
          pincode_id: this.pincode,
          latitude: this.latitude,
          longitude: this.longitude,
        },
        work_hour_attributes: {
          id: this.work_hour_id,
          start_time: this.start_time,
          end_time: this.end_time,
          days: this.days,
        },
        pincode_ids: this.pincodes,
      }
    }

    if (this.ops_pincodes.trim() !== "") {
      apiJson.service_center.pincodes = this.ops_pincodes.replace(/\s/g, "").split(',');
    }

    return apiJson;
  }

  prepareServiceCenterCategoryObj = () => {
    let category_ids_arr = this.category_ids.map((category_obj) => category_obj.category_id)
    let existing_category_ids_arr = this.existing_categories.map((existing_category_obj) => existing_category_obj.category_id)
    let deleted_categories = this.existing_categories.filter((existing_category) => category_ids_arr.indexOf(existing_category.category_id) === -1)

    let new_categories = category_ids_arr.filter((id)=> existing_category_ids_arr.indexOf(id) === -1 )
    let serviceCenterParams = []
    serviceCenterParams = serviceCenterParams.concat(deleted_categories.map((deletedCategory) => {
      return { ...deletedCategory, _destroy: true}
      })
    )
    serviceCenterParams = serviceCenterParams.concat(new_categories.map((id)=> {
      return {category_id: id}
      })
    )
    return serviceCenterParams;
  }

  validations = (field) => {
    return {
      service_center_type: () => {
        if (this[field].trim() === "") {
          this.errors.service_center_type = "Select Service Center Type.";
        }
        else {
          delete this.errors.service_center_type;
        }
      },
      sloc: () => {
        if (this[field].trim() === "") {
          this.errors.sloc = "Service Location cannot be blank.";
        }
        else {
          delete this.errors.sloc;
        }
      },
      name: () => {
        if (this[field].trim() === "") {
          this.errors.name = "Name cannot be blank.";
        }
        else {
          delete this.errors.name;
        }
      },
      tally_account_id: () => {
        if (this[field].trim() === "") {
          this.errors.tally_account_id = "SAP code cannot be blank.";
        }
        else {
          delete this.errors.tally_account_id;
        }
      },
      cs_ware_house_id: () => {
        if (this[field].trim() === "") {
          this.errors.cs_ware_house_id = "Please select pincode warehouse.";
        }
        else {
          delete this.errors.cs_ware_house_id;
        }
      },
      branch_id: () => {
        if (this[field] === "") {
          this.errors.branch_id = "Please select Circle.";
        }
        else {
          delete this.errors.branch_id;
        }
      },
      start_time: () => {
        if (this[field] === ""){
          this.errors.start_time = "This field is required.";
        } else if (this[field] >= this.end_time) {
          this.errors.start_time = "Start time should be less than End time.";
        }
        else {
          delete this.errors.start_time;
          if(this.end_time !== ""){
            delete this.errors.end_time;
          }
        }
      },
      end_time: () => {
        if (this[field] === ""){
          this.errors.end_time = "This field is required.";
        } else if (this[field] <= this.start_time) {
          this.errors.end_time = "End time should be greater than Start time.";
        }
        else {
          delete this.errors.end_time;
          if(this.start_time !== ""){
            delete this.errors.start_time;
          }
        }
      },
      category_ids: () => {
        if (this[field].length === 0) {
          this.errors.category_ids = "Please select category/categories.";
        }
        else {
          delete this.errors.category_ids;
        }
      },
      days: () => {
        if (this[field].trim() === "") {
          this.errors.days = "Select at least one day.";
        }
        else {
          delete this.errors.days;
        }
      },
      address: () => {
        if (this[field].trim() === "") {
          this.errors.address = "Address cannot be blank.";
        }
        else {
          delete this.errors.address;
        }
      },
      pincode: () => {
        if (this[field] === "") {
          this.errors.pincode = "Please select pincode.";
        }
        else {
          delete this.errors.pincode;
        }
      },
      pincodes: () => {
        if (this[field].length === 0) {
          this.errors.pincodes = "Please select operational pincode/pincodes.";
        }
        else {
          delete this.errors.pincodes;
        }
      },
      latitude: () => {
        const latitude = this[field];
        const longitude = this.longitude;
    
        if (latitude !== "" && (latitude < -90 || latitude > 90)) {
          this.errors.latitude = "Invalid latitude format.";
        } else if (latitude !== "" && longitude === "") {
          this.errors.latitude = "Longitude is required when latitude is filled.";
        } else {
          delete this.errors.latitude;
        }
    },
    longitude: () => {
        const longitude = this[field];
        const latitude = this.latitude;
    
        if (longitude !== "" && (longitude < -180 || longitude > 180)) {
          this.errors.longitude = "Invalid longitude format.";
        } else if (longitude !== "" && latitude === "") {
          this.errors.longitude = "Latitude is required when longitude is filled.";
        } else {
          delete this.errors.longitude;
        }
    }    
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default ServiceCenter;
